module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "mt-0 pa-0",
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.invoices), function(invoice) {
    return [_c('invoice-list-item', {
      key: ("item-" + (invoice.id)),
      class: {
        'light-blue lighten-5': _vm.isSelected(invoice)
      },
      attrs: {
        "withStatus": _vm.withStatus,
        "withStatusBorder": _vm.withStatusBorder,
        "invoice": invoice
      },
      on: {
        "clicked": function($event) {
          return _vm.$emit("selected", invoice)
        }
      }
    }, [(_vm.actions.length > 0) ? _c('v-list-tile-action', {
      staticClass: "thin",
      attrs: {
        "slot": "actionsBefore"
      },
      slot: "actionsBefore"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setSelectedInvoice(invoice)
        }
      }
    }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.primaryAction) ? _c('v-list-tile-action', {
      attrs: {
        "slot": "actionsAfter"
      },
      slot: "actionsAfter"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit('primarycta', invoice)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(_vm.primaryAction.icon))])], 1)], 1) : _c('v-list-tile-action', {
      attrs: {
        "slot": "actionsAfter"
      },
      slot: "actionsAfter"
    }, [_c('strong', {
      staticClass: "subheading mt-3"
    }, [_vm._v(_vm._s(_vm.getAmountDue(invoice)))]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("Due")])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (invoice.id))
    })]
  }), _vm._v(" "), (_vm.invoices && _vm.invoices.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [(!_vm.loading) ? _c('span', [_vm._v("No invoices found")]) : _c('span', [_c('v-progress-circular', {
    staticClass: "amber--text",
    attrs: {
      "size": 10,
      "width": 1,
      "small": "",
      "indeterminate": ""
    }
  }), _vm._v("\n            loading ..\n          ")], 1)])], 1) : _vm._e(), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "scrollable": ""
    },
    model: {
      value: (_vm.bottomsheet),
      callback: function($$v) {
        _vm.bottomsheet = $$v
      },
      expression: "bottomsheet"
    }
  }, [(_vm.selectedInvoice && _vm.selectedInvoice.id) ? [_c('v-subheader', {
    staticClass: "grey lighten-4 overline py-0 my-0"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("post_add")]), _vm._v("\n          " + _vm._s(_vm.selectedInvoice.title) + "\n          "), (_vm.viewUrl) ? _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "icon": "",
      "target": "_blank",
      "href": _vm.viewUrl
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-3",
    attrs: {
      "small": "",
      "flat": "",
      "outline": _vm.sheetWindow === 0,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.sheetWindow = 0
      }
    }
  }, [_vm._v("Actions")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "outline": _vm.sheetWindow === 1,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.sheetWindow = 1
      }
    }
  }, [_vm._v("Appointments")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.selectedInvoice.status) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    staticStyle: {
      "padding": "0px 5px",
      "margin": "0px",
      "float": "right"
    },
    attrs: {
      "color": _vm.statusColor,
      "text-color": "white",
      "label": ""
    }
  }, [_vm._v(_vm._s(_vm.selectedInvoice.status.toUpperCase()) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.closeBottomSheet
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.sheetWindow),
      callback: function($$v) {
        _vm.sheetWindow = $$v
      },
      expression: "sheetWindow"
    }
  }, [_c('v-window-item', [_c('v-list', _vm._l((_vm.actions), function(action) {
    return _c('v-list-tile', {
      key: action.icon,
      attrs: {
        "disabled": action.disableIf && action.disableIf(_vm.selectedInvoice),
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.$root.$emit(action.action, _vm.selectedInvoice);
          _vm.bottomsheet = false
        }
      }
    }, [_c('v-list-tile-title', {
      on: {
        "click": function($event) {
          return _vm.$emit(action.action, _vm.selectedInvoice)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(action.icon))]), _vm._v(" " + _vm._s(action.text) + "\n                  ")], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-window-item', [_c('v-card', [_c('v-card-text', {
    staticClass: "pa-0",
    staticStyle: {
      "overflow-y": "auto",
      "height": "550px"
    }
  }, [_c('invoice-payments', {
    attrs: {
      "invoice": _vm.selectedInvoice,
      "transactions": _vm.selectedInvoice.transaction_set
    }
  }, [_c('template', {
    slot: "subheader"
  }, [_c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "small": "",
      "outline": "",
      "color": "primary",
      "disabled": !_vm.selectedInvoice,
      "loading": _vm.requests.enrich.loading
    },
    on: {
      "click": _vm.refreshInvoice
    }
  }, [_vm._v("\n                        Update invoice\n                        "), _c('help-popover', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("\n                          Click to update the appointments on this invoice."), _c('br'), _vm._v("\n                          Changes below are on the appointments attached to this invoice."), _c('br'), _vm._v("\n                          Make sure to click this button to update your invoice to reflect any changes made below.\n                        ")])], 1), _vm._v(" "), (_vm.requests.enrich.status === 200) ? _c('span', {
    staticClass: "caption success--text"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("check")]), _vm._v(" Invoice updated\n                    ")], 1) : _vm._e()], 1)], 2)], 1)], 1)], 1)], 1)] : _vm._e()], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ec711cc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/InvoiceList.vue
// module id = 1438
// module chunks = 9